import React, { useEffect, useState } from 'react'
import { Note } from '@sukiai/components'
import { compose, graphql } from 'react-apollo'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../../lib/constants'
import { GetOrganizationById } from '@sukiai/gql/admin'
import get from 'lodash.get'
import loSto from '../../config/loSto'
import { isAmwellTheme, LO_STO } from '../../lib'
import { getNoteEditorMarginProps } from '../../lib/helpers'

const NoteContainer = ({
  sections,
  metadata,
  veilActive,
  dictation,
  setDictation,
  stopDictation,
  clearSection,
  currentSectionState,
  currentSection,
  deleteEmptyProblemSection,
  search,
  isDosEditable,
  schedulePicker,
  dobPicker,
  genderPicker,
  mrnInput,
  editableStatesForPickers,
  setEditableState,
  scripts,
  orgData,
  notetypeDestinations,
  agentState
}) => {
  const [hasEMR, setHasEMR] = useState(null)
  const [isSukiOnly, setIsSukiOnly] = useState(null)

  useEffect(() => {
    const isEMROrganization = orgData?.organizations?.results[0]?.emr?.id !== null
    setHasEMR(isEMROrganization)
  }, [orgData])

  useEffect(() => {
    const isSukiOnlyNoteType = notetypeDestinations?.includes('SUKI_ONLY')
    setIsSukiOnly(isSukiOnlyNoteType)
  }, [notetypeDestinations])

  const isSmallWindow = isAmwellTheme() || useMediaQuery({
    query: `(max-width: ${RESPONSIVE.NOTE_SMALL_WIDTH})`
  })

  const isWrapUpWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.NOTE_LARGE_WIDTH})`
  })

  const marginProps = getNoteEditorMarginProps()

  return (
    <Note
      sections={sections}
      metadata={metadata}
      veilActive={veilActive}
      dictation={dictation}
      setDictation={setDictation}
      stopDictation={stopDictation}
      clearSection={clearSection}
      currentSectionState={currentSectionState}
      currentSection={currentSection}
      deleteEmptyProblemSection={deleteEmptyProblemSection}
      search={search}
      isDosEditable={isDosEditable}
      schedulePicker={schedulePicker}
      dobPicker={dobPicker}
      genderPicker={genderPicker}
      mrnInput={mrnInput}
      editableStatesForPickers={editableStatesForPickers}
      setEditableState={setEditableState}
      isSmallWindow={isSmallWindow}
      isWrapUpWindow={isWrapUpWindow}
      scripts={scripts}
      hasEMR={hasEMR}
      isSukiOnly={isSukiOnly}
      agentState={agentState}
      {...marginProps}
    />
  )
}

const mapOrgToProps = ({ orgData }) => ({
  orgError: orgData.error,
  orgLoading: orgData.loading,
  orgData: get(orgData, 'organizations.results[0]')
})

export default compose(
  graphql(GetOrganizationById, {
    name: 'orgData',
    options: () => ({
      variables: {
        id: loSto.get(LO_STO.ORGANIZATION_ID),
        withEmrInfo: true
      },
      props: mapOrgToProps
    })
  })
)(NoteContainer)
